module.exports = __webpack_public_path__ + "static/img/accelerate.2392ac28.svg";